import { LoanComparisonIcon } from "../../../atoms/icons/loan-comarison";
import React, { useMemo } from "react";

export const MobileBottomBar = ({
  isComparedIds,
  setIsComparisonView,
  quotes,
}) => {
  const containerClassName = useMemo(() => {
    const classNames = ["mobile-bottom-bar"];

    if (quotes.length >= 1) {
      classNames.push("compare-active");
    }

    return classNames.join(" ");
  }, [quotes]);

  return (
    <div
      className={containerClassName}
      onClick={() => quotes.length >= 1 && setIsComparisonView(true)}
    >
      <LoanComparisonIcon fill="white" />
      <div className="bold">Compare {isComparedIds.length} Loan Options</div>
      <div className="filler" />
    </div>
  );
};
